import type { DrawerHeaderProps } from './types';

import { Dropdown } from 'antd';

import { AvatarCircle } from '../../atoms/AvatarCircle';
import { Typography } from '../../atoms/Typography';
import { Icon } from '../../atoms/icons';

const DrawerHeader = ({ icon, name, menuProps }: DrawerHeaderProps) => (
  <div className={'flex-col border-b border-[#D2D6DB]'}>
    <div className={'flex m-6 items-center justify-between'}>
      <div className={'flex items-center'}>
        <AvatarCircle
          size={'lg'}
          icon={{
            ...icon,
            className: `${icon.className} w-8 h-8`
          }}
        />
        <Typography fontFace={'BodyRegularLg'} className={'text-gray-900 ml-6'}>
          {name}
        </Typography>
      </div>
      {menuProps ? (
        <Dropdown
          trigger={['click']}
          placement={'bottomRight'}
          menu={menuProps}
        >
          <div
            className={
              'flex p-1 rounded-lg border border-[#D2D6DB] shadow-sm cursor-pointer rotate-90'
            }
          >
            <Icon iconName={'iconDotsThreeVertical'} width={16} height={16} />
          </div>
        </Dropdown>
      ) : null}
    </div>
  </div>
);

export { DrawerHeader };
